import { render, staticRenderFns } from "./Allowedcurrency.vue?vue&type=template&id=e66f7132"
import script from "./Allowedcurrency.vue?vue&type=script&lang=js"
export * from "./Allowedcurrency.vue?vue&type=script&lang=js"
import style0 from "./Allowedcurrency.vue?vue&type=style&index=0&id=e66f7132&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports